import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../seo/SEOHead';
import PageHeader from '../components/PageHeader';

const MinistryRefugees = () => {
  return (
    <>
      <SEOHead path="/ministry-for-refugees" />
      <PageHeader title="Ministry for Refugees" breadcrumb="Ministry for Refugees" />

      <section className="section">
        <div className="container">
          <div className="content-page fade-in">
            <div className="content-body" style={{ textAlign: 'center', padding: '60px 24px' }}>
              <p style={{ fontSize: '18px', fontStyle: 'italic', marginBottom: '24px' }}>
                "The foreigner residing among you must be treated as your native-born. Love them as yourself, for you were foreigners in Egypt." — Leviticus 19:34
              </p>
              <p>Upholding this biblical mandate, our organization aids newcomers in securing housing, employment, and societal integration, fostering a welcoming community for displaced individuals.</p>
              <p style={{ marginTop: '32px' }}>
                <Link to="/contact" className="hero-cta" style={{ display: 'inline-block' }}>
                  Get in Touch →
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MinistryRefugees;
